import appConfig from '@/config/applicationConfig.js'

export const AdminServiceMixin = {
  data () {
    return {
      USER_ENDPOINT: `${appConfig.API_END_POINT}/admin/user`,
      USER_HEADER: {
        headers: {
          Authorization: `Bearer ${this.$store.state.access_token}`
        }
      }
    }
  },
  methods: {
    getUsers (filter) {
      let endpoint = new URL(this.USER_ENDPOINT)
      Object.keys(filter).forEach(
        key => {
          let value = filter[key]
          if (key === 'sortOrder') value = value ? 'asc' : 'desc'
          if (key === 'from') --value
          if (value !== null) {
            endpoint.searchParams.append(key, value)
          }
        }
      )
      return this.$http.get(endpoint.href, this.USER_HEADER)
    },
    getUser (id) {
      return this.$http.get(this.USER_ENDPOINT + `/${id}`, this.USER_HEADER)
    },
    createUser (user) {
      return this.$http.post(this.USER_ENDPOINT, user, this.USER_HEADER)
    },
    updateUser (user) {
      return this.$http.put(this.USER_ENDPOINT + `/${user.id}`, user, this.USER_HEADER)
    },
    deleteUser (id) {
      return this.$http.delete(this.USER_ENDPOINT + `/${id}`, this.USER_HEADER)
    },
    resetPassword (userId) {
      return this.$http.post(this.USER_ENDPOINT + `/passwordreset/${userId}`, {}, this.USER_HEADER)
    },
    changePassword (userId, body) {
      return this.$http.post(this.USER_ENDPOINT + `/${userId}/newpassword`, body, this.USER_HEADER)
    },
    existEmail (email) {
      return this.$http.get(`${appConfig.API_END_POINT}/admin/emails/${email}`, this.USER_HEADER)
    }
  }
}

export const RoleService = {
  data: function () {
    return {
      roleProperties: {
        'CATALOGER_USER': { name: 'Catalogador', variant: 'dark' },
        'ADMIN_USER': { name: 'Administrador Marketplace', variant: 'primary' },
        'LOGISTICS_ADMIN': { name: 'Administrador Logístico', variant: 'primary' },
        'STANDARD_USER': { name: 'Usuario Marketplace', variant: 'primary' },
        'ORGANIZATION_ADMIN_USER': { name: 'Administrador Seller', variant: 'dark' },
        'ORGANIZATION_STANDARD_USER': { name: 'Usuario Seller', variant: 'dark' },
        'CATALOG_USER': { name: 'Catálogo', variant: 'secondary' },
        'ORDERS_USER': { name: 'Pedidos', variant: 'secondary' },
        'INVENTORY_USER': { name: 'Inventario', variant: 'secondary' },
        'CARRIERS_USER': {name: 'Transportadoras', variant: 'secondary'},
        'REPORTS_USER': { name: 'Reportes', variant: 'secondary' }
      }
    }
  },
  methods: {
    getRoles () {
      return this.$http.get(
        `${appConfig.API_END_POINT}/admin/role`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    getRole (id) {
      return this.$http.get(
        `${appConfig.API_END_POINT}/admin/role/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    createRole (role) {
      return this.$http.post(
        `${appConfig.API_END_POINT}/admin/role`,
        role,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    updateRole (id, role) {
      return this.$http.get(
        `${appConfig.API_END_POINT}/admin/role/${id}`,
        role,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    deleteRole (id) {
      return this.$http.delete(
        `${appConfig.API_END_POINT}/admin/role/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    sortValidRoles (roles) {
      let response = [
        'CATALOGER_USER',
        'ADMIN_USER',
        'LOGISTICS_ADMIN',
        'ORGANIZATION_ADMIN_USER',
        'ORGANIZATION_STANDARD_USER',
        'STANDARD_USER',
        'CATALOG_USER',
        'ORDERS_USER',
        'INVENTORY_USER',
        'CARRIERS_USER',
        'REPORTS_USER'
      ]
      return response.map(r => roles.find(role => role.roleName === r)).filter(r => r !== undefined)
    }
  }
}

export const OrganizationService = {
  data () {
    return {
      ORGANIZATION_ENDPOINT: `${appConfig.API_END_POINT}/admin/organization`,
      HEADER: {
        headers: {
          Authorization: `Bearer ${this.$store.state.access_token}`
        }
      }
    }
  },
  methods: {
    async getAllOrganizations () {
      let total = 0
      let organizationArray = []
      let size = 100
      let from = 1
      do {
        let response = await this.getOrganizations({
          'from': from,
          'size': size
        })
        total = parseInt(response.headers.get('X-Total-Count'))
        organizationArray = organizationArray.concat(response.body)
        from = from + 1
      } while (total !== organizationArray.length)

      return organizationArray
    },
    getSearchSeller (text) {
      let endpoint = new URL(this.ORGANIZATION_ENDPOINT)
      if (text) {
        endpoint.searchParams.append('text', text)
      }
      return this.$http.get(endpoint.href, this.HEADER)
    },
    getOrganizations (filter) {
      let endpoint = new URL(this.ORGANIZATION_ENDPOINT)
      if (filter) {
        Object.keys(filter).forEach(
          key => {
            let value = filter[key]
            if (key === 'sortOrder') value = value ? 'asc' : 'desc'
            if (key === 'from') value = value - 1
            if (key === 'sortBy' && value !== 'accountName') value = value + '.keyword'
            if (value !== null) {
              endpoint.searchParams.append(key, value)
            }
          }
        )
      }
      return this.$http.get(endpoint.href, this.HEADER)
    },
    searchOrganization (text) {
      let endpoint = new URL(this.ORGANIZATION_ENDPOINT)
      endpoint.searchParams.append('text', text)
      return this.$http.get(endpoint.href, this.HEADER)
    },
    saveOrganization (organization) {
      return this.$http.post(this.ORGANIZATION_ENDPOINT, organization, this.HEADER)
    }
  }
}
